import { useState } from 'react';
import DoctorNotesfull from './DoctorNotesfull';

export default function DoctorNotes({ data }) {
  const notes = data || '';
  const maxChars = 150;  // max number of characters
  const isTruncated = notes.length > maxChars;
  const shortNotes = isTruncated ? notes.slice(0, maxChars) : notes;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <pre className="baseText text-navLink whitespace-pre-wrap break-words overflow-x-hidden w-full p-4 bg-lightBlue rounded-lg text-sm leading-relaxed">
        {isTruncated ? (
          <>
            {shortNotes}
            {'... '}
            <span
              className="text-accent cursor-pointer inline font-medium"
              onClick={() => setIsOpen(true)}
            >
              View More
            </span>
          </>
        ) : (
          notes
        )}
      </pre>

      <DoctorNotesfull show={isOpen} data={data} setclose={setIsOpen} />
    </>
  );
}
